import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { withTranslation } from '../../src/i18n';

import { borderRadius, colors } from '../../constants/styleConstants';

const useStyles = makeStyles()({
  cardBox: {
    height: 'auto',
    border: `1px solid ${colors.border.grey1}`,
    borderRadius: borderRadius.input,
    backgroundColor: colors.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

const CardBox = ({ children, className }) => {
  const { classes, cx } = useStyles();
  return <div className={cx(classes.cardBox, className)}>{children}</div>;
};

CardBox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default withTranslation('translation')(CardBox);
